import { HttpContextToken } from '@angular/common/http';
/** Authentication handling remains active; feature-owned translated notifications replace the generic error toast. */
export const SKIP_HTTP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
